import React from 'react';
import MuiGrid2, { Grid2Props as MuiGrid2Props } from '@mui/material/Grid2';

/**
 * A functional component that renders a MUI Grid component.
 *
 * @param {MuiGrid2Props} props - The properties passed to the MUI Grid component.
 * @returns {React.ReactElement} The rendered MUI Grid component with the given props.
 *
 * @category Component
 */
export const Grid = (props: MuiGrid2Props): React.ReactElement => {
  return <MuiGrid2 {...props}>{props.children}</MuiGrid2>;
};
